module.exports = __webpack_public_path__ + "img/UTHYRU-1.474f2fe9.jpg";